import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  const renderTableByLevel = () => {
    let dynamicCols = 0;

    if ([UserLevel.National, UserLevel.Province].includes(currentLevel)) {
      dynamicCols += 1; // Kabupaten
    }
    if (
      [UserLevel.National, UserLevel.Province, UserLevel.District].includes(
        currentLevel
      )
    ) {
      dynamicCols += 1; // Puskesmas
    }
    if (
      [
        UserLevel.National,
        UserLevel.Province,
        UserLevel.District,
        UserLevel.Fasyankes,
      ].includes(currentLevel)
    ) {
      dynamicCols += 1; // Desa
    }

    const totalCols = 4 + dynamicCols;
    return (
      <>
        <thead>
          <tr>
            <th>No.</th>
            <th>Nama Fasyankes</th>
            <th>Melakukan Uji Silang (Ya/Tidak)</th>
            <th>Dilakukan Bimtek (Ya/Tidak)</th>
            <th>Dilakukan Profisiensi Tes (Ya/Tidak)</th>
            <th>Rekap PME (Uji Silang/ Bimtek/ Profisiensi)</th>
          </tr>
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item?.fasyankes_name}</td>
                <td>{item?.cross_check}</td>
                <td>{item?.bimtek_test}</td>
                <td>{item?.proficiency_test}</td>
                <td>{item?.pme_summary}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={totalCols}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>Laporan PME Bulanan</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {periodeName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode?.year}
            </th>
          </tr>
          {reportInfo?.statusPeriode === "monthly" && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                Bulan
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
              </th>
            </tr>
          )}
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0}}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
